import { getRouteParams } from './getRouteParams';
export const getIntegrationKey = () => {
  return getRouteParams().integrationKey;
};